import { render, staticRenderFns } from "./DisplayDetails.vue?vue&type=template&id=c240495e&scoped=true&"
import script from "./DisplayDetails.vue?vue&type=script&lang=js&"
export * from "./DisplayDetails.vue?vue&type=script&lang=js&"
import style0 from "./DisplayDetails.vue?vue&type=style&index=0&id=c240495e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c240495e",
  null
  
)

component.options.__file = "DisplayDetails.vue"
export default component.exports